import { ButtonLoading } from 'components/Buttons'
import { useEffect, useState } from 'react'
import FormattedMessage from 'utils/FormattedMessage'
import { WifiOffSvg } from './WifiOffSvg'

export const OfflineWarning = () => {
  const [isOffline, setIsOffline] = useState(false)

  useEffect(() => {
    setIsOffline(!navigator.onLine)
    const handleOffline = () => setIsOffline(true)
    const handleOnline = () => setIsOffline(false)

    window.addEventListener('offline', handleOffline)
    window.addEventListener('online', handleOnline)

    return () => {
      window.removeEventListener('offline', handleOffline)
      window.removeEventListener('online', handleOnline)
    }
  }, [])

  if (!isOffline) return null

  return (
    <div className='fixed inset-0 z-[9999] flex items-center justify-center px-4'>
      <div className='absolute inset-0 bg-gray-500 bg-opacity-75' />
      <div className='relative flex flex-col items-center bg-white rounded-lg shadow-xl px-8 py-10 w-full max-w-sm'>
        <div className='w-[190px] mt-4 mb-8'>
          <WifiOffSvg />
        </div>
        <h1 className='text-gray-700 text-2xl font-bold text-center'>
          <FormattedMessage id='offline' />
        </h1>
        <p className='text-sm text-gray-800 text-center my-5 max-w-[85%]'>
          <FormattedMessage id='offline.description' />
        </p>
        <ButtonLoading onClick={() => window.location.reload()} style='w-full !mb-0 mt-4'>
          <FormattedMessage id='offline.retry' />
        </ButtonLoading>
      </div>
    </div>
  )
}
